import React, { useState } from 'react';
import styles from './index.module.scss';
import rightPrimary from '../../../../assets/global/rightPrimary.svg';
import store from '../../../../assets/global/store.png';
import { ctLogV2 } from '../../../../utils/cleverTapLogger.utils';
import { useIdHash, useNavigateRoute } from '../../../../hooks/custom.hooks';
import { get } from 'lodash';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { viewportToPixels } from '../../../../utils/common.utils';
import ClaimBS from './components/ClaimBS';
import CustomImg from '../../../../components/CustomImg';
import FadeInSection from '../../../../wrapper/FadeInWrapper';

export const parseColorCode = (code = '') => {
  const parsedCode = code ?? '';
  return parsedCode.includes('#') || parsedCode.startsWith('rgb')
    ? parsedCode
    : `#${parsedCode}`;
};

export const OfferTypeAndExpiry = ({ offer }) => {
  const {
    tag_url,
    tag_text,
    tag_color,
    expiry_text,
    expiry_logo,
    expiry_text_color,
  } = offer || {};
  return (
    <div className={styles.offerType}>
      {tag_url ? (
        <img src={tag_url} alt={tag_text} className={styles.tag} />
      ) : null}
      {tag_text || expiry_text ? (
        <div
          className={styles.offerTypeText}
          style={{
            color: parseColorCode(tag_color),
          }}
        >
          {tag_text}
          {expiry_text ? (
            <div
              className={styles.expiryText}
              style={{
                color: parseColorCode(expiry_text_color),
              }}
            >
              |
              <img
                src={expiry_logo}
                alt="expiry"
                className={styles.expiryLogo}
              />
              {expiry_text}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

function OfferCard({ offer = {}, data }) {
  const {
    offer_title,
    brand_logo,
    brand_name,
    offer_subtitle,
    offer_filter_type,
    voucher_campaign_details_id,
    type,
    voucher_id,
    reward_details_id,
    brand_id,
    code,
    applicable_brand_logos,
    offer_tag,
  } = offer || {};
  const merchantNames = applicable_brand_logos?.brand_names
    ?.slice(0, 25)
    .join(', ');
  let showClaim = ['recommended', 'exclusive'].includes(offer_filter_type);
  // @TODO: implement Later @akash
  showClaim = false;
  const { custId: cid } = useIdHash();
  let brandLogo =
    brand_logo?.includes('twidpay.com') ||
    brand_logo?.includes('twidapp.com') ||
    brand_logo === null
      ? (brand_logo ?? store)
      : `https://cdn.twidpay.com/co${brand_logo}`;

  const allFilters = get(data, 'filters', {});
  const offerTypeText =
    allFilters.offer_type.find((offer) => offer.id === offer_tag).data || '';

  const [open, setOpen] = useState(false);
  const navigateRoute = useNavigateRoute();
  return (
    <FadeInSection>
      <div
        className={styles.offerCard}
        id={`offerCard${brand_id}`}
        onClick={() => {
          localStorage.setItem(
            'offerListST',
            document.getElementById('offersScroll')?.scrollTop || 0,
          );
          localStorage.setItem('offerTypeText', offerTypeText);
          navigateRoute({
            nextPage: `/offer/${brand_id}?vcdi=${voucher_campaign_details_id}&t=${type}&vid=${voucher_id}&rdid=${reward_details_id}`,
          });
          ctLogV2({
            eventName: 'Web_Offer_clicked',
            eventCategory: 'Offer Listing Page',
            eventDescription: 'Offer Listing Page - Web Offer Clicked',
            customerId: cid,
            extraData: {
              offerID:
                voucher_id ||
                reward_details_id ||
                voucher_campaign_details_id ||
                type ||
                '',
              coupon_code: code,
              offer_title: offer_title,
              offer_subtitle: offer_subtitle,
              offer_type: offerTypeText,
              Merchants: merchantNames,
            },
          });
        }}
      >
        <div className={styles.left}>
          <CustomImg
            src={brandLogo}
            fallbackSrc={store}
            alt={brand_name}
            // id={`brandImg_${keyIndex}`}
            className={styles.brandLogo}
            // onError={() => {
            //   document.getElementById(`brandImg_${keyIndex}`).src = store;
            // }}
          />
          <div>{brand_name}</div>
        </div>
        <div className={styles.right}>
          <OfferTypeAndExpiry offer={offer} />
          <div className={styles.offerInfo}>
            <div className={styles.offerTitle}>{offer_title}</div>
            <div className={styles.offerSubTitle}>{offer_subtitle}</div>
          </div>
          {showClaim ? (
            <div
              className={styles.claimBtn}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setOpen(true);
              }}
            >
              Claim
              <img src={rightPrimary} alt=">" className={styles.rightPri} />
            </div>
          ) : null}
        </div>
      </div>
      <BottomSheet
        open={open}
        onDismiss={() => setOpen(false)}
        header={false}
        initialFocusRef={false}
        maxHeight={viewportToPixels('75vh')}
        style={{
          overflow: 'hidden',
          background: '#1C2B5A',
        }}
      >
        <ClaimBS />
      </BottomSheet>
    </FadeInSection>
  );
}

export default OfferCard;
